import React from "react";
import { styled } from "../../stitches.config";

interface ISettings {
  title: string;
  description: string;
  link: string;
  enabled_vote?: boolean;
  enabled_articles?: boolean;
}
interface BridPrimaryHeaderBoxProps {
  settings: ISettings;
}

const BridPrimaryHeaderBox: React.FC<BridPrimaryHeaderBoxProps> = ({ settings, ...props }) => {
  return (
    <>
      <Heading size="big">{settings.title}</Heading>
      <Paragraph variant="primary">
        {settings.description}{settings.link && <a href={settings.link}>Czytaj więcej</a>}
      </Paragraph>
      <WrapperButtons>
        {settings.enabled_articles &&
          <Button href="#block--b-headline--1" type={"primary"}>
            Czytaj artykuły
          </Button>
        }
        {settings.enabled_vote &&
          <Button href={"#block--brid-timer-three--1"} type={"secondary"}>
            Oddaj Głos
          </Button>
        }
      </WrapperButtons>
    </>
  );
};

const Heading = styled("h1", {
  color: "$grayscale0Fixed",
  fontSize: "12px",
  marginTop: 0,
  marginBottom: "8px",
  "@bp4": {
    fontSize: "12px"
  },
  variants: {
    size: {
      "big": {
        fontSize: "34px",
        marginBottom: "16px",
        "@bp4": {
          fontSize: "54px"
        }
      }
    }
  }
});

const Paragraph = styled("p", {
  color: "#ccc",
  fontSize: "14px",
  lineHeight: "18px",
  marginTop: 0,
  fontWeight: 600,
  marginBottom: "11px",
  "@bp4": {
    fontSize: "16px",
    lineHeight: "16px",
    marginBottom: "11px"
  },
  "a": {
    marginLeft: "4px",
    textDecoration: "underline",
    transition: "0.3s",
    "&:hover": {
      color: "$primary !important"
    }
  },
  variants: {
    "variant": {
      "primary": {
        color: "#fff",
        marginBottom: "24px",
        "@bp4": {
          marginBottom: "32px",
          lineHeight: "24px"
        }
      }
    }
  }
});

const WrapperButtons = styled("div", {
  display: "flex"
});

const Button = styled("a", {
  width: "48%",
  display: "block",
  color: "$grayscale100Fixed",
  backgroundColor: "#F5F5F5",
  border: "2px solid #F5F5F5",
  padding: "11px 25px",
  textAlign: "center",
  fontWeight: 600,
  cursor: "pointer",
  "@bp3": {
    width: "auto"
  },
  "&:first-child": {
    marginRight: "16px"
  },
  "&:hover, &:visited": {
    textDecoration: "none",
    color: "$grayscale100Fixed"
  },
  variants: {
    type: {
      "primary": {
        color: "$grayscale0Fixed",
        backgroundColor: "$primary",
        border: "2px solid #FF6400",
        "&:hover, &:visited": {
          color: "$grayscale0Fixed"
        }
      },
      "secondary": {}
    }
  }
});

export default BridPrimaryHeaderBox;
